import { render } from 'react-dom';
import videojs from 'videojs-mux-kit';
import { SeekBar } from '../components/SeekBar';
import { jsx as _jsx } from "react/jsx-runtime";
const createSeekBarPlugin = (player, options) => {
  const {
    chapters,
    duration
  } = options;
  player.ready(() => {
    const seekBar = document.createElement('div');
    seekBar.className = 'hs-seek-bar';
    seekBar.setAttribute('data-test-id', 'hs-seek-bar');
    player.el().classList.add('hs-with-seek-bar');
    player.el().appendChild(seekBar);
    render( /*#__PURE__*/_jsx(SeekBar, {
      chapters: chapters,
      duration: duration / 1000,
      player: player,
      playButtonColor: options.playButtonColor,
      primaryPlaybackId: options.primaryPlaybackId
    }), seekBar);
  });
};
const seekBarPlugin = function seekBarPlugin(options) {
  createSeekBarPlugin(this, options);
};
seekBarPlugin.VERSION = '1';
videojs.registerPlugin('seekBar', seekBarPlugin);
export default seekBarPlugin;